module.exports = __webpack_public_path__ + "img/mes favoris.6bfccfa1.png";